import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (window.location.href.indexOf("fallback|") !== -1 || window.location.href.indexOf("fallback%7C") !== -1) {
  const session = window.location.href.split("session=")[1];
  localStorage.setItem(
    "redirect",
    window.location.href
      .split("/access")[0]
      .replace("https://", "")
      .replace("http://", "")
  );
  window.location.href = "/access?session=" + session;
}
